import React from 'react';
import { useSelector } from 'react-redux';
import questions from '../../survey/questions';
import questionsMan from '../../surveyMan/questionsMan';

function OnlyOneOption (props) {
	const planMan = useSelector((state) => state.global.planMan);
	const questionsType = planMan ? questionsMan : questions;

	function chooseAnswer () {
		questionsType.addOnlyAnswer({
			questionName: props.questionName,
			answer: props.option
		});

		props.actionOnClick();
	}

	return (
		<button
			type="button"
			className={`${props.className} ${props.isOptionSelected ? (props.selectedStateClass) : ''}`}
			onClick={() => {
				chooseAnswer();
				props.runOnChoose && props.runOnChoose();
			}}
			tabIndex={props.disableFromFocus ? -1 : ''}
		>
			{props.children}
		</button>
	);
}

export default OnlyOneOption;
